module.exports = __webpack_public_path__ + "static/media/7_Materiali-OSA_20150626.c92d12f4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/7_Materiali-OSA_20150626.pdf
// module id = 190
// module chunks = 0